<mat-form-field
  class="typeahead-field"
  *ngIf="visibleOptions?.length > 10 || needsSearch">
  <input
    matInput
    data-atm="typeahead-input"
    [(ngModel)]="searchString"
    (keyup)="searchOptions()" />
  <mat-label>Search {{ labelText }}s</mat-label>
</mat-form-field>
<div
  *ngIf="shouldDisplaySelectedOptionsCount"
  class="filter-options-action-header">
  <span class="selected-options-count"
    ><b>{{ selectedOptionsCount }}</b> selected</span
  >
  <a mat-flat-button class="clear-all link-button" (click)="clearAllOptions()"
    >Clear all</a
  >
</div>

<div class="filter-options-container">
  <span
    class="help-text"
    *ngIf="!visibleOptions.length && !shouldDisplayNoResults">
    Try typing in a {{ labelText || "anything" }} to see results.
  </span>
  <span class="help-text" *ngIf="shouldDisplayNoResults">
    No results found. Try adjusting your search terms to see results.
  </span>
  <ng-container *ngFor="let option of visibleOptions; let last = last">
    <div class="option" *ngIf="!option.isHidden" [ngClass]="{ 'mb-16': !last }">
      <mat-checkbox
        [value]="option.value"
        [(ngModel)]="option.isSelected"
        (change)="handleCheckedFilterOption(option)"
        [checked]="option.isSelected"
        >{{ option.label }}</mat-checkbox
      >
      <div class="bottom-text">
        <span *ngIf="option.bottomTextLeft" class="option-text-left">{{
          option.bottomTextLeft
        }}</span>
        <span *ngIf="option.bottomTextRight" class="option-text-right">{{
          option.bottomTextRight
        }}</span>
      </div>
    </div>
  </ng-container>
</div>
